import React, { useEffect } from 'react';
import { LoadingButton } from '../../common/OnboardingPage';
import './ConfirmationModal.scss';


const ConfirmationModal = ({ children, close, confirm, confirmText, disabled = false, additionalClassName = '', loading = false, loadingText = null, confirmRef = null }) => {
  useEffect(() => {
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, []);

  return (
    <section
      className={`confirmation-modal-container ${additionalClassName}`}
      role={'dialog'}
      aria-modal={'true'}
      onClick={(e) => e.stopPropagation()}
      onMouseDown={(e) => e.stopPropagation()}
    >
      <section className={'confirmation-modal'}>
        <section className={'confirmation-modal-content'}>
          {children}
          {loading && loadingText && <p className={'loading-text'}>{loadingText}</p>}
          <section className={'buttons'}>
            <button className={`cancel very-dark ${loading ? 'disabled' : ''}`} type={'button'} onClick={close} disabled={loading}>{'Cancel'}</button>
            <LoadingButton loading={loading} classNames={['confirm', 'very-dark', disabled ? 'disabled' : '']} onClick={confirm} text={confirmText} buttonRef={confirmRef} disabled={disabled} />
          </section>
        </section>
      </section>
    </section>
  );
};

export default ConfirmationModal;
